export const singlePrice = 25;
export const kwPackages = [{
    price: singlePrice,
    count: 1
}, {
    price: 60,
    count: 3
}, {
    price: 90,
    count: 5
}, {
    price: 160,
    count: 10
}, {
    price: 330,
    count: 25
}, {
    price: 570,
    count: 50
}];
export const companyName = 'GLOBETECH SOLUTIONS LTD'
export const address = '20 Wenlock Road, London, N1 7GU, England'
export const email = 'kontakt@geoksiegi.pl'
